import React, {Component} from 'react';
const { Link } = require('react-router');

import '../../sass/headers/header.scss';


class HeaderPopularSearches extends Component
{
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render()
    {
        return (
            <header className="popularsearches">
                <div className="content">
                    <h1>The most popular searches</h1>
                    <div className="text-popularsearches">
                        <p><a href="#">View all member list</a> of profiles registered on the webcam chat.</p>
                    </div>
                </div>
            </header>
        )
    }
}

export default HeaderPopularSearches;


// WEBPACK FOOTER //
// ./src/components/popularsearches/HeaderPopularSearches.js